import { render, staticRenderFns } from "./ScoringProfilesModelDefinition.vue?vue&type=template&id=0499aa46&scoped=true"
import script from "./ScoringProfilesModelDefinition.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesModelDefinition.vue?vue&type=script&lang=js"
import style0 from "./ScoringProfilesModelDefinition.vue?vue&type=style&index=0&id=0499aa46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499aa46",
  null
  
)

export default component.exports